import { DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import { PmiButton } from 'shell/components/shared/button';

interface ModalExitProps {
  closeCancelDialog?: () => void;
  isCancelDialogOpen?: boolean;
  onCancel?: () => void;
}

const ModalExit = ({
  closeCancelDialog,
  isCancelDialogOpen,
  onCancel,
}: ModalExitProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  const navigate = useNavigate();

  return (
    <PmiDialog
      open={isCancelDialogOpen || false}
      onClose={closeCancelDialog}
      aria-labelledby="close-modal"
      aria-describedby="close-modal"
      fullWidth
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="close-modal-title" backgroundColor="primary" color="white">
        Stampe
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        Annulla operazione comporta la perdita di tutti i dati digitati, si è sicuri di voler
        continuare?
      </DialogContent>
      <DialogActions>
        <PmiButton
          variant="contained"
          color="cdmBrand"
          type="button"
          onClick={() => {
            if (onCancel) {
              onCancel();
              return;
            }
            navigate('/cancellazioni/minori');
          }}
        >
          Conferma Annullo
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={closeCancelDialog}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalExit.displayName = 'Modal Exit component';

export default ModalExit;
